import { useSearchParams } from "react-router-dom";
import { Calculator, Timer, Shield, HeartHandshake } from "lucide-react";
import PageHero from "@/components/shared/PageHero";
import LeadForm from "@/components/shared/LeadForm";

export default function RequestQuotation() {
  const [sp] = useSearchParams();
  const preset = sp.get("product") ? `Please share bulk quotation for: ${sp.get("product")}` : "";

  return (
    <div>
      <PageHero
        label="Request Quotation"
        title="Bulk pricing on your requirements."
        subtitle="Share your product interest, quantities, and business details. Our sales team responds with a formal bulk quotation, MOQ, and delivery timeline within 24 hours."
        breadcrumbs={[{ label: "Request Quotation" }]}
      />
      <section className="py-14">
        <div className="mx-auto max-w-6xl px-4 md:px-8 grid md:grid-cols-5 gap-10">
          <div className="md:col-span-2 space-y-6">
            {[
              { icon: Calculator, t: "Transparent Pricing", d: "Clear wholesale rates with proper billing and no hidden fees." },
              { icon: Timer, t: "24-Hour Response", d: "A dedicated executive reaches out within one working day." },
              { icon: Shield, t: "Original Stock", d: "All brands supplied with authentic tags and proper billing." },
              { icon: HeartHandshake, t: "Long-term Terms", d: "Grow together with credit terms for verified regular partners." },
            ].map((f, i) => (
              <div key={i} className="flex gap-4 p-5 rounded-md border border-border/60 bg-card">
                <div className="h-10 w-10 rounded-sm bg-gold/10 text-gold flex items-center justify-center shrink-0">
                  <f.icon size={18} strokeWidth={1.5} />
                </div>
                <div>
                  <h4 className="font-serif text-lg text-foreground">{f.t}</h4>
                  <p className="mt-1 text-sm text-foreground/70">{f.d}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="md:col-span-3">
            <div className="p-8 rounded-md border border-border/60 bg-card">
              <p className="section-label mb-3">Business Requirements</p>
              <h3 className="serif-display text-3xl text-foreground">Get a bulk quotation.</h3>
              <p className="mt-2 text-sm text-foreground/70">Tell us your product needs — we'll respond with wholesale pricing.</p>
              <div className="mt-6">
                <LeadForm
                  type="quotation"
                  presetMessage={preset}
                  submitLabel="Request Quotation"
                  showFields={["company_name","contact_person","phone","email","gst","business_type","state","city","monthly_purchase","message"]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
